const logger = require('od-modules/utils/logger');

const UPDATED = 'UPDATED';

const REQUIRED_PROPERTIES = {
    id: '',
    type: '',
};

const isValid = (notification = {}) => Object.entries(REQUIRED_PROPERTIES).every(([key, type]) => {
    return notification[key] && typeof notification[key] === typeof type;
});

const logInvalidNotification = (notification = {}) => {
    logger.error(new Error(JSON.stringify(notification)), 'notifications-manager:validateNotification');
};
const logDuplicateNotificationId = (old, newNotification) => {
    logger.error(new Error(JSON.stringify({old, 'new': newNotification})), 'notifications-manager:validateNotificationId');
};

const Queue = Backbone.Model.extend({
    notifications: [],

    getNotifications() {
        return this.notifications;
    },

    addNotification(notification) {
        if (isValid(notification)) {
            const duplicateIndex = this.findById(notification.id);
            if (duplicateIndex === -1) {
                this.notifications.push(notification);
                this.trigger(UPDATED);
            } else {
                logDuplicateNotificationId(this.notifications[duplicateIndex], notification);
            }
        } else {
            logInvalidNotification(notification);
        }
    },

    findById(notificationId) {
        return this.notifications.findIndex(({id} = {}) => id === notificationId);
    },

    updateNotification(data) {
        if (isValid(data)) {
            const index = this.findById(data.id);

            if (index < 0) {
                this.addNotification(data);
            } else {
                this.notifications[index] = data;
                this.trigger(UPDATED);
            }
        } else {
            logInvalidNotification(data);
        }
    },

    deleteNotification(id) {
        const index = this.findById(id);

        if (index >= 0) {
            this.notifications.splice(index, 1);
            this.trigger(UPDATED);
        }
    },

    clear() {
        this.notifications = [];
    },
});

module.exports = {
    queue: new Queue(),
    UPDATED,
};
